// extracted by mini-css-extract-plugin
module.exports = {"card":"Bu939k","logoContainer":"DMPxe7","cardText":"qCfmCo","cardName":"_4iUIo9","cardDescription":"dLItf5"};